export default __webpack_public_path__ + "static/media/5.19d8b35c.jpg";